import { signOut } from "next-auth/react";

export default async function federatedLogout() {
  try {
    const response = await fetch("/api/auth/federated-logout");

    // Comprobar si la respuesta del servidor es correcta
    if (!response.ok) {
      console.error(`Error en el servidor: ${response.status}`);
      await signOut({ redirect: false });
      window.location.href = "/";
      return;
    }

    const data = await response.json();

    // Redirigir al URL proporcionado en la respuesta
    if (data.url) {
      await signOut({ redirect: false });
      window.location.href = data.url;
    } else {
      console.error("No se recibió una URL válida para el logout federado.");
      await signOut({ redirect: false });
      window.location.href = "/";
    }
  } catch (error) {
    console.error("Error en la solicitud de logout federado:", error);
    await signOut({ redirect: false });
    window.location.href = "/";
  }
}
